var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('success-message',{attrs:{"message":_vm.messageSuccess}}),_c('Header'),_c('div',{staticClass:"layout-main pb-[48px]"},[_c('router-view')],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }